module.exports = __webpack_public_path__ + "static/img/banner-bg2.c6681ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner-bg2.png
// module id = 4EWm
// module chunks = 1